import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.167 1.834v1.333m0 10.667v1.333M2.833 8.5H1.5m2.876-3.79-.943-.943m8.524.943.943-.943m-8.524 8.527-.943.942m8.524-.943.943.943M14.833 8.5H13.5m-2 0a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0"
    }, null, -1)
  ])))
}
export default { render: render }